module.exports = __webpack_public_path__ + "static/media/copy.c82fed72.svg";